import styled from 'styled-components';

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-small);
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-x-small);

  input {
    width: 280px;
  }
`;
